namespace GeniuzPOS.Lookups {
    export interface SysParaRow {
        Id?: number;
        SysFg?: number;
        SysGroup?: number;
        SysName?: string;
        SysDesc?: string;
        SysFgDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace SysParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysName';
        export const localTextPrefix = 'Lookups.SysPara';
        export const lookupKey = 'Lookups.SysPara';

        export function getLookup(): Q.Lookup<SysParaRow> {
            return Q.getLookup<SysParaRow>('Lookups.SysPara');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysFg = "SysFg",
            SysGroup = "SysGroup",
            SysName = "SysName",
            SysDesc = "SysDesc",
            SysFgDesc = "SysFgDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
